(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["katadyn-samejan-2026"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initializeCampaign = () => {
    const root = document.querySelector('#katadyn-samejan-2026');
    if (!root || root.dataset.campaignInitialized === 'true') return;
    root.dataset.campaignInitialized = 'true';

    const start = new Date('2026-10-01T00:00:00+08:00');
    const end = new Date('2026-12-31T23:59:59+08:00');
    const countdown = root.querySelector('#countdown');
    const formatter = new Intl.NumberFormat('zh-TW', { minimumIntegerDigits: 2 });

    const updateCountdown = () => {
      if (!countdown) return;
      const now = new Date();
      const target = now < start ? start : end;
      if (now > end) {
        countdown.textContent = '活動已結束';
        return;
      }
      const diff = target - now;
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const prefix = now < start ? '距離開始' : '距離結束';
      countdown.textContent = `${prefix} ${days} 天 ${formatter.format(hours)} 小時`;
    };

    updateCountdown();
    window.setInterval(updateCountdown, 60000);

    const mobileCta = root.querySelector('.mobile-cta');
    const hero = root.querySelector('.hero');
    const stepsAction = root.querySelector('.steps-action');
    const gift = root.querySelector('.gift');
    const coupon = root.querySelector('.coupon-section');
    const closing = root.querySelector('.closing');
    if (!mobileCta || !hero || !stepsAction || !gift || !coupon || !closing || !('IntersectionObserver' in window)) return;

    let heroVisible = true;
    let stepsActionVisible = false;
    let giftVisible = false;
    let couponVisible = false;
    let closingVisible = false;

    const syncMobileCta = () => {
      mobileCta.classList.toggle('is-visible', !heroVisible && !stepsActionVisible && !giftVisible && !couponVisible && !closingVisible);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === hero) heroVisible = entry.isIntersecting;
        if (entry.target === stepsAction) stepsActionVisible = entry.isIntersecting;
        if (entry.target === gift) giftVisible = entry.isIntersecting;
        if (entry.target === coupon) couponVisible = entry.isIntersecting;
        if (entry.target === closing) closingVisible = entry.isIntersecting;
      });
      syncMobileCta();
    }, { threshold: 0.05 });

    [hero, stepsAction, gift, coupon, closing].forEach((element) => observer.observe(element));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCampaign, { once: true });
  } else {
    initializeCampaign();
  }
  document.addEventListener('shopify:section:load', initializeCampaign);
})();

  } catch(e) { console.error(e); }
})();
})();
